module.exports = __webpack_public_path__ + "img/pccw.d7e904f4.png";